import { render, staticRenderFns } from "./CustomerCTUpload.vue?vue&type=template&id=99a2bd7e&scoped=true"
import script from "./CustomerCTUpload.vue?vue&type=script&lang=js"
export * from "./CustomerCTUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a2bd7e",
  null
  
)

export default component.exports